import type { CSSProperties } from "react";
import { C, font } from "../theme";

interface FilterPillsProps {
  options: string[];
  value: string;
  onChange: (value: string) => void;
  style?: CSSProperties;
}

/** Grupo de pílulas de filtro (ativo = fundo ink, inativo = branco). */
export function FilterPills({ options, value, onChange, style }: FilterPillsProps) {
  return (
    <div style={{ display: "flex", gap: 6, flexWrap: "wrap", ...style }}>
      {options.map(opt => {
        const active = value === opt;
        return (
          <button
            key={opt}
            onClick={() => onChange(opt)}
            style={{
              fontFamily: font,
              fontSize: 12,
              fontWeight: 700,
              cursor: "pointer",
              padding: "6px 13px",
              borderRadius: 20,
              background: active ? C.ink : C.white,
              color: active ? C.white : C.gray,
              border: `1px solid ${active ? C.ink : C.faint}`,
            }}
          >
            {opt}
          </button>
        );
      })}
    </div>
  );
}
